import { cn } from '@ixigo/iui/variantStyle';
import { ASSETS } from '../content/assets';
import { HERO_CONTENT } from '../content/content';

// ixigo home, the click target for the header logo across the CBCC pages.
const IXIGO_HOME_URL = 'https://www.ixigo.com';

// Shared header logo: the ixigo wordmark (or the orange text-chip fallback when
// ASSETS.ixigoLogo is empty), wrapped in a link to the ixigo homepage. Used by
// every top-of-page header in the feature (hero, stage header/chrome, apply,
// comparison, manage card) so the logo + its home link stay single-source.
//
// External navigation → a plain <a> (not the router Link): ixigo.com is outside
// this SPA. `imgClassName` tunes the logo height per header (h-7 / h-8 today);
// `className` styles the anchor wrapper if needed.
export function IxigoLogo({
	imgClassName = 'h-8 w-auto object-contain',
	className,
}: {
	imgClassName?: string;
	className?: string;
}) {
	return (
		<a
			href={IXIGO_HOME_URL}
			aria-label={HERO_CONTENT.logoAlt}
			className={cn('inline-flex shrink-0 items-center', className)}
		>
			{ASSETS.ixigoLogo ? (
				<img
					src={ASSETS.ixigoLogo}
					alt={HERO_CONTENT.logoAlt}
					className={imgClassName}
				/>
			) : (
				<span className="rounded bg-ixigo-credit px-3 py-1 text-sm font-bold text-white">
					{HERO_CONTENT.logoAlt}
				</span>
			)}
		</a>
	);
}
